import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { defaultEmployeeLifecycleConfiguration } from 'libs/end-to-end/src/dynamic-pipeline-analysis-configuration';

export const PipelineAnalysisExtras = z.object({
  dimension: z.string(),
  analysisName: z.string().optional(),
  filters: z.array(FilterDefinitionForExtras),
});

export type PipelineAnalysisExtras = z.infer<typeof PipelineAnalysisExtras>;

export const PipelineAnalysisInputs = z.object({
  dropdowns: EmptyObject,
  extras: PipelineAnalysisExtras,
});

export const PipelineAnalysisRequest = createCustomVizRequestSchema(
  'pipelineAnalysis',
  PipelineAnalysisInputs,
);

export type PipelineAnalysisRequest = z.infer<typeof PipelineAnalysisRequest>;

export const getAnalysisNameFromPipelineAnalysisRequest = (
  request: PipelineAnalysisRequest,
): string => {
  return (
    request.inputs.extras.analysisName ??
    defaultEmployeeLifecycleConfiguration.name
  );
};
